"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.starts-with");
var _i18n = require("@/utils/i18n");
var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      levelList: null
    };
  },
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  },
  watch: {
    $route: function $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created: function created() {
    this.getBreadcrumb();
  },
  methods: {
    generateTitle: _i18n.generateTitle,
    getBreadcrumb: function getBreadcrumb() {
      var route = this.$route;
      var query = route.query;
      // only show routes with meta.title
      var matched = this.$route.matched.filter(function (item) {
        return item.meta && item.meta.title;
      });
      var first = matched[0];
      if (!this.isDashboard(first)) {
        matched = [{
          path: '/dashboard',
          meta: {
            title: 'Dashboard'
          }
        }].concat(matched);
      }
      // cwt  active breadcrumb
      // 只替换状态值
      var nameList = ['cwt_vehicle_list', 'cwt_breakbulk_list', 'cwt_operati_list'];
      if (query.breadcrumb) {
        var breadcrumb = JSON.parse(query.breadcrumb);
        matched.forEach(function (item) {
          if (nameList.includes(item.name && item.name.toLowerCase())) item.meta.title = breadcrumb[item.name.toLowerCase()];
        });
      }
      this.levelList = matched.filter(function (item) {
        return item.meta && item.meta.title && item.meta.breadcrumb !== false;
      });
    },
    isDashboard: function isDashboard(route) {
      var name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase();
    },
    pathCompile: function pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      var params = this.$route.params;
      var toPath = _pathToRegexp.default.compile(path);
      return toPath(params);
    },
    handleLink: function handleLink(data) {
      var redirect = data.redirect,
        path = data.path;
      // 从tagView获取visitedViews数据
      var tmp = this.visitedViews.filter(function (item) {
        return item.path === path;
      });
      // console.log(this.visitedViews)

      if (!tmp || tmp.length === 0) {
        if (redirect) {
          this.$router.push(redirect);
          return;
        }
        this.$router.push(this.pathCompile(path));
      } else {
        this.$router.push({
          path: tmp[0].path,
          query: tmp[0].query
        });
      }
    }
  }
};